import type { I18n } from '@lingui/core';
import { CARE_ALERT_COPY, getActionLabel, isCareAlertCategory } from '@/types/workflow';

/**
 * Plain-words copy for the Acknowledge and Dismiss confirm dialogs: what the
 * action means, and a confirm button that carries the action name. The intro
 * says "This means:" because the sentences explain the action, not what the
 * system does. Every other action returns nothing, so the dialog keeps its own
 * behaviour.
 */
export function transitionDialogCopy(
  i18n: I18n,
  action: string,
  category?: string,
): { summary?: string; summaryIntro?: string; confirmLabel?: string } {
  if (action !== 'acknowledge' && action !== 'dismiss') return {};
  const confirmLabel = getActionLabel(i18n, action);
  const summaryIntro = i18n._({ id: 'workflow.transition.meaningIntro', message: 'This means:' });
  if (category === 'coverage_breach') {
    return {
      confirmLabel,
      summaryIntro,
      summary:
        action === 'acknowledge'
          ? i18n._({
              id: 'workflow.transition.coverageBreach.acknowledgeSummary',
              message: 'You checked the understaffing. The item will be closed.',
            })
          : i18n._({
              id: 'workflow.transition.coverageBreach.dismissSummary',
              message: 'The understaffing is known, for example planned. The item will be closed.',
            }),
    };
  }
  if (isCareAlertCategory(category)) {
    const copy = CARE_ALERT_COPY[category];
    return {
      confirmLabel,
      summaryIntro,
      summary: action === 'acknowledge' ? copy.acknowledgeSummary(i18n) : copy.dismissSummary(i18n),
    };
  }
  return {
    confirmLabel,
    summaryIntro,
    summary: i18n._({ id: 'workflow.transition.closedSummary', message: 'The item will be closed.' }),
  };
}
